var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 14.665C4.31859 14.665 1.33496 11.6814 1.33496 8.00002C1.33496 4.31865 4.31859 1.33502 7.99996 1.33502C11.6813 1.33502 14.665 4.31865 14.665 8.00002C14.665 11.6814 11.6813 14.665 7.99996 14.665ZM7.37512 8.00002C7.37512 8.2083 7.47926 8.40357 7.65369 8.49729L10.1531 10.1635C10.4395 10.377 10.8274 10.2989 10.9966 10.0125C11.2101 9.72615 11.132 9.33823 10.8456 9.14557L8.6248 7.66677V4.45924C8.6248 4.11297 8.34623 3.8344 7.97653 3.8344C7.65369 3.8344 7.35169 4.11297 7.35169 4.45924L7.37512 8.00002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.e2f7fd6d7c642c72b801be68593799ec.svg";
export { ForwardRef as ReactComponent };